import { render, staticRenderFns } from "./portfolio-stat-card.vue?vue&type=template&id=4c64a3b0&scoped=true&"
import script from "./portfolio-stat-card.ts?vue&type=script&lang=ts&"
export * from "./portfolio-stat-card.ts?vue&type=script&lang=ts&"
import style0 from "./portfolio-stat-card.scss?vue&type=style&index=0&id=4c64a3b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64a3b0",
  null
  
)

export default component.exports